// extracted by mini-css-extract-plugin
module.exports = {"container":"StopWastingTimeSection_container__hGUXZ","subTitle":"StopWastingTimeSection_subTitle__milwJ","featuresWrapper":"StopWastingTimeSection_featuresWrapper__aroR_"};